import { useState } from 'react';
import type { MeetingBucket } from '@wundo/shared/calendar.ts';
import { storeAgendaBuckets, storedAgendaBuckets } from '@/lib/agendaBuckets.ts';
import { toggleBucket, type AgendaFilterValue } from './agendaFilter.ts';

/** Which drawers of the calendar are showing, as the user last left them in this browser. */
export function useAgendaBuckets() {
  const [buckets, setBuckets] = useState<readonly MeetingBucket[]>(storedAgendaBuckets);

  const toggle = (value: AgendaFilterValue) => {
    const next = toggleBucket(buckets, value);
    setBuckets(next);
    storeAgendaBuckets(next);
  };

  return { buckets, toggle };
}
